import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Lock } from 'plurall-icons'

import styles from './Question.module.css'

class Question extends Component {
  state = {
    showMessage: false,
  }

  handleMouseOverLock = () => {
    this.setState({ showMessage: true })
  }

  handleMouseLeaveLock = () => {
    this.setState({ showMessage: false })
  }

  render() {
    const { showMessage } = this.state
    const { title, text } = this.props

    return (
      <div className={styles.question}>
        <div className={styles.block}>
          <span className={styles.title}> {title} </span>
          <div onMouseOver={this.handleMouseOverLock} onMouseLeave={this.handleMouseLeaveLock}>
            <Lock color='red' />
          </div>
          {showMessage && (
            <span className={styles.message}>
              Essa questão ainda está bloqueada. Você poderá fazer quando seu professor liberar. :)
            </span>
          )}
        </div>
        <span className={styles.content} dangerouslySetInnerHTML={{ __html: text }}></span>
      </div>
    )
  }
}

Question.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
}

export default Question
